import { Translations } from './fr';

export const nl: Translations = {
  nav: {
    home: "Home",
    primeEvolution: "Evolution",
    pulse: "Pulse",
    sparkle: "Sparkle",
    agents: "Agenten",
    partners: "Partners",
    contact: "Contact",
    recruitAgent: "Agent Werven",
  },
  hero: {
    title: "Werf onze",
    titleHighlight: "AI-Agenten",
    titleEnd: "om uw Teams te Versterken",
    subtitle: "Virtuele medewerkers 24/7 beschikbaar, getraind op uw bedrijfsprocessen, klaar om uw productiviteit te transformeren.",
    cta: "Werf een AI-Agent",
    discover: "Ontdek Prime Evolution",
  },
  trust: {
    available: "24/7 Beschikbaar",
    secure: "100% Veilig",
    agents: "Gecertificeerde Agenten",
    support: "Toegewijd Ondersteuning",
  },
  primeEvolution: {
    badge: "Onze Vlaggenschipoplossing",
    title: "Prime Evolution",
    subtitle: "Het complete begeleidingsprogramma om AI in uw bedrijf te integreren",
    description: "Prime Evolution is onze holistische aanpak die audit, training en implementatie van op maat gemaakte AI-agenten combineert.",
    features: {
      audit: { title: "Strategische Audit", description: "Diepgaande analyse van uw processen om automatiseringsmogelijkheden te identificeren." },
      training: { title: "Teamtraining", description: "Aangepaste trainingsprogramma's voor effectieve samenwerking met AI." },
      deployment: { title: "Aangepaste Implementatie", description: "Gepersonaliseerde AI-agenten geïntegreerd met uw bestaande tools." },
      support: { title: "Continue Ondersteuning", description: "Toegewijde ondersteuning en continue optimalisatie." },
    },
    cta: "Start Prime Evolution",
    stats: { productivity: "Gemiddelde productiviteitswinst", roi: "Rendement op investering", satisfaction: "Klanttevredenheidspercentage" },
  },
  pulse: {
    badge: "Intelligente Automatisering",
    title: "VEECTORIA Pulse",
    subtitle: "Automatisering die pulseert op het ritme van uw bedrijf",
    description: "Pulse is ons intelligente automatiseringsplatform dat uw workflows in realtime verbindt en orkestreert.",
    features: {
      connect: { title: "Verbind", description: "Native integratie met meer dan 200 professionele tools." },
      orchestrate: { title: "Orkestreer", description: "Intelligente workflows die zich automatisch aanpassen." },
      optimize: { title: "Optimaliseer", description: "Realtime analyse en aanbevelingen om processen te verbeteren." },
    },
    cta: "Ontdek Pulse",
  },
  advantages: {
    badge: "Waarom Voor Ons Kiezen",
    title: "VEECTORIA Voordelen",
    subtitle: "Een unieke aanpak die menselijke expertise combineert met AI-kracht",
    items: {
      expertise: { title: "Erkende Expertise", description: "Meer dan 10 jaar ervaring in digitale transformatie en AI." },
      custom: { title: "Aangepaste Oplossingen", description: "Elke agent wordt specifiek getraind op uw processen." },
      security: { title: "Maximale Veiligheid", description: "Data gehost in Europa, AVG-naleving gegarandeerd." },
      roi: { title: "Gegarandeerde ROI", description: "Toezegging op resultaten met meetbare indicatoren." },
      support: { title: "24/7 Ondersteuning", description: "Toegewijd team altijd beschikbaar." },
      evolution: { title: "Continue Evolutie", description: "Uw agenten verbeteren constant door machine learning." },
    },
  },
  sparkle: {
    badge: "Intelligente Digitalisering",
    title: "Sparkle",
    subtitle: "TagPDF v7 met AI",
    description: "Transformeer uw papieren documenten in bruikbare gegevens met onze intelligente digitaliseringsoplossing. Automatische herkenning, gegevensextractie en intelligente classificatie.",
    features: {
      scan: {
        title: "Geavanceerde Digitalisering",
        description: "Hoogwaardige OCR voor alle documenttypes.",
      },
      ai: {
        title: "Geïntegreerde AI",
        description: "Automatische classificatie en extractie van belangrijke gegevens.",
      },
      speed: {
        title: "Ultrasnelle Verwerking",
        description: "Duizenden pagina's verwerkt in minuten.",
      },
      accuracy: {
        title: "Maximale Nauwkeurigheid",
        description: "Herkenningsgraad boven 99%.",
      },
    },
    cta: "Ontdek Sparkle",
    ctaFulltext: "Full-text Indexering",
    ctaFulltextDesc: "Zoek direct in al uw documenten.",
    ctaScan: "Bliksem Scan → Map",
    ctaScanDesc: "Scan en organiseer in een oogwenk.",
  },
  testimonials: {
    badge: "Getuigenissen",
    title: "Ze Vertrouwen Ons",
    subtitle: "Ontdek hoe onze klanten hun bedrijf transformeren met VEECTORIA",
    items: [
      { quote: "Dankzij VEECTORIA hebben we administratieve taken met 70% verminderd.", metric: "-70%", metricLabel: "admin tijd", name: "Isabelle G.", role: "Administratief Manager" },
      { quote: "De commerciële AI-agent heeft onze prospectie getransformeerd. +40% gekwalificeerde afspraken.", metric: "+40%", metricLabel: "gekwalificeerde afspraken", name: "Marc D.", role: "Commercieel Directeur" },
      { quote: "De documentoplossing bespaart ons waardevolle tijd bij dossierbeheer.", metric: "5x", metricLabel: "sneller", name: "Sophie M.", role: "Manager" },
    ],
  },
  faq: {
    badge: "Veelgestelde Vragen",
    title: "Alles over VEECTORIA",
    subtitle: "Antwoorden op uw meest voorkomende vragen",
    items: {
      q1: { question: "Wat is een VEECTORIA AI-Agent?", answer: "Een intelligente virtuele medewerker getraind op uw specifieke bedrijfsprocessen." },
      q2: { question: "Hoe lang duurt de implementatie?", answer: "Standaardimplementatie duurt 2-4 weken, voor complexere behoeften 6-8 weken." },
      q3: { question: "Zijn mijn gegevens veilig?", answer: "Absoluut. Alle gegevens worden in Europa gehost op gecertificeerde servers, 100% AVG-conform." },
      q4: { question: "Wat is het verwachte rendement?", answer: "Onze klanten zien gemiddeld 40% productiviteitswinst en positieve ROI binnen 3 maanden." },
      q5: { question: "Hoe werkt de integratie?", answer: "VEECTORIA integreert native met meer dan 200 professionele tools." },
    },
  },
  contact: {
    badge: "Neem Contact Op",
    title: "Klaar om uw Bedrijf te Transformeren?",
    subtitle: "Laten we uw behoeften bespreken en ontdekken hoe VEECTORIA u kan ondersteunen",
    form: {
      name: "Volledige naam",
      email: "Professionele e-mail",
      company: "Bedrijf",
      phone: "Telefoon",
      message: "Uw bericht",
      submit: "Bericht verzenden",
      sending: "Verzenden...",
      success: "Bericht succesvol verzonden!",
      error: "Fout bij verzenden. Probeer het opnieuw.",
    },
    info: { title: "Contactinformatie", email: "E-mail", phone: "Telefoon", address: "Adres" },
  },
  cta: {
    title: "Klaar om Actie te Ondernemen?",
    subtitle: "Sluit u aan bij de bedrijven die hun productiviteit al hebben getransformeerd met VEECTORIA",
    button: "Werf een AI-Agent",
  },
  footer: {
    description: "Kunstmatige intelligentie-oplossingen om uw bedrijf te transformeren.",
    navigation: "Navigatie",
    legal: "Juridische Kennisgeving",
    privacy: "Privacybeleid",
    terms: "Algemene Voorwaarden",
    cookies: "Cookie-instellingen",
    rights: "Alle rechten voorbehouden.",
  },
  agents: {
    badge: "Ons Team",
    title: "Onze AI-Agenten",
    subtitle: "Ontdek onze virtuele medewerkers klaar om bij uw team te komen",
  },

  // AI Agents Showcase
  agentsShowcase: {
    badge: "AI-Excellentie voor Uw Bedrijf",
    title: "Onze AI-Agenten Transformeren Uw Dagelijks Werk",
    description: "Stel u een team virtuele medewerkers voor dat nooit slaapt, continu leert en zich perfect aanpast aan uw bedrijfsprocessen. Onze AI-Agenten versterken uw capaciteiten, bevrijden uw talenten van repetitieve taken en stuwen uw productiviteit naar nieuwe hoogten.",
    imageAlt: "VEECTORIA AI-Agenten Team",
    cta: "Ontdek Onze Agenten",
    benefits: {
      availability: "24/7 Beschikbaar",
      productivity: "10x Productiviteit",
      performance: "Optimale Prestaties",
      collaboration: "Naadloze Samenwerking",
    },
  },
  cookies: {
    title: "Cookiebeheer",
    message: "We gebruiken cookies om uw ervaring op onze site te verbeteren, verkeer te analyseren en inhoud te personaliseren.",
    accept: "Alles accepteren",
    decline: "Weigeren",
    settings: "Aanpassen",
    settingsTitle: "Cookie-instellingen",
    settingsDescription: "Beheer uw cookievoorkeuren. Essentiële cookies zijn noodzakelijk voor de werking van de site en kunnen niet worden uitgeschakeld.",
    saveChoices: "Mijn keuzes opslaan",
    rejectAll: "Alles weigeren",
    alwaysActive: "Altijd actief",
    categories: {
      essential: { name: "Essentiële cookies", description: "Deze cookies zijn noodzakelijk voor de werking van de site en kunnen niet worden uitgeschakeld." },
      analytics: { name: "Analytische cookies", description: "Deze cookies stellen ons in staat het publiek van de site te meten en het browsegedrag te analyseren." },
      marketing: { name: "Marketingcookies", description: "Deze cookies worden gebruikt om gepersonaliseerde advertenties aan te bieden." },
      preferences: { name: "Voorkeurscookies", description: "Deze cookies onthouden uw voorkeuren (taal, thema, regio)." },
    },
  },

  // Partners Section
  partners: {
    badge: "Partnerprogramma",
    title: "Laten We Samen Bouwen",
    description: "Bent u reseller, distributeur, software-editor of groothandel? VEECTORIA wordt uw bevoorrechte technologiepartner om nieuwe markten te veroveren met geavanceerde AI-oplossingen.",
    valueProposition: "Wij ontwerpen en ontwikkelen complete, op maat gemaakte professionele oplossingen voor uw klanten, terwijl we u ondersteunen bij het implementeren van een massacommercialisatiestrategie. Aantrekkelijke marges, toegewijde technische ondersteuning en marketingondersteuning: alle ingrediënten voor uw succes.",
    types: {
      resellers: { title: "Resellers", description: "Integreer onze AI-oplossingen in uw catalogus en bied onderscheidende pakketten." },
      distributors: { title: "Distributeurs", description: "Implementeer onze technologieën op grote schaal in uw gebied." },
      editors: { title: "Software-editors", description: "Verrijk uw software met onze AI voor ongeëvenaarde meerwaarde." },
      wholesalers: { title: "Groothandels", description: "Krijg voorkeurstarieven voor massadistributie via uw netwerken." },
    },
    benefits: {
      title: "Uw Partnervoordelen",
      whiteLabel: "White-label oplossingen",
      support: "Toegewijde technische ondersteuning",
      scalability: "Onbeperkte schaalbaarheid",
    },
    cta: "Word Partner",
    ctaSubtext: "Neem contact op om ons exclusieve partnerprogramma te ontdekken",
  },

  legal: {
    lastUpdate: "Laatst bijgewerkt: januari 2026",
    mentions: {
      title: "Juridische Kennisgeving",
      sections: {
        editor: { title: "1. Website-uitgever", intro: "Deze website wordt uitgegeven door:", companyName: "Bedrijfsnaam", legalForm: "Rechtsvorm", capital: "Maatschappelijk kapitaal", address: "Maatschappelijke zetel", siren: "SIREN", siret: "SIRET", rcs: "RCS", tva: "BTW-nummer", naf: "NAF-code" },
        publication: { title: "2. Publicatieverantwoordelijke", intro: "Publicatie wordt beheerd door:", since: "sinds" },
        contact: { title: "3. Contact", phone: "Telefoon", email: "E-mail" },
        hosting: { title: "4. Hosting", intro: "De website wordt gehost door:", name: "Naam", address: "Adres" },
        intellectual: { title: "5. Intellectueel eigendom", content1: "Deze gehele website is onderworpen aan Franse en internationale wetgeving inzake auteursrecht en intellectueel eigendom.", content2: "Reproductie van deze website geheel of gedeeltelijk is strikt verboden zonder uitdrukkelijke toestemming van" },
        liability: { title: "6. Beperking van aansprakelijkheid", content: "De informatie op deze website is zo nauwkeurig mogelijk. {company} kan niet aansprakelijk worden gesteld voor directe of indirecte schade als gevolg van het gebruik van deze website." },
        law: { title: "7. Toepasselijk recht", content: "Deze website is onderworpen aan Frans recht. Bij geschillen zijn uitsluitend Franse rechtbanken bevoegd." },
      },
    },
    privacy: {
      title: "Privacybeleid",
      sections: {
        intro: { title: "1. Inleiding", content: "{company} verbindt zich ertoe de privacy van websitegebruikers te beschermen. Dit privacybeleid legt uit hoe wij uw persoonsgegevens verzamelen, gebruiken en beschermen conform de AVG." },
        controller: { title: "2. Verwerkingsverantwoordelijke", company: "Bedrijf", address: "Adres", email: "E-mail" },
        data: { title: "3. Verzamelde gegevens", intro: "Wij verzamelen de volgende gegevens:", items: ["Identificatiegegevens: naam, voornaam, e-mail, telefoon", "Professionele gegevens: bedrijf, functie", "Navigatiegegevens: IP-adres, cookies, bezochte pagina's", "Communicatiegegevens: berichten via contactformulieren"] },
        purposes: { title: "4. Verwerkingsdoeleinden", intro: "Uw gegevens worden verzameld voor:", items: ["Beantwoorden van uw contactverzoeken", "Leveren van onze AI-diensten", "Verbeteren van onze website", "Versturen van commerciële communicatie (met uw toestemming)", "Voldoen aan wettelijke verplichtingen"] },
        basis: { title: "5. Rechtsgrondslag", intro: "De verwerking is gebaseerd op:", items: ["Uw uitdrukkelijke toestemming", "Uitvoering van een contract", "Ons gerechtvaardigd belang", "Wettelijke verplichtingen"] },
        retention: { title: "6. Bewaartermijn", content: "Uw gegevens worden bewaard voor de benodigde duur, maximaal 3 jaar na uw laatste contact." },
        rights: { title: "7. Uw rechten", intro: "Conform de AVG heeft u de volgende rechten:", access: "Recht van toegang", accessDesc: "een kopie van uw gegevens verkrijgen", rectification: "Recht op rectificatie", rectificationDesc: "onjuiste gegevens corrigeren", erasure: "Recht op verwijdering", erasureDesc: "verwijdering van uw gegevens verzoeken", restriction: "Recht op beperking", restrictionDesc: "verwerking beperken", portability: "Recht op overdraagbaarheid", portabilityDesc: "gegevens in gestructureerd formaat ontvangen", objection: "Recht van bezwaar", objectionDesc: "bezwaar maken tegen verwerking", contact: "Om deze rechten uit te oefenen, neem contact op:" },
        security: { title: "8. Beveiliging", content: "Wij nemen passende technische en organisatorische maatregelen om uw gegevens te beschermen." },
        complaint: { title: "9. Klacht", content: "U kunt een klacht indienen bij de CNIL: www.cnil.fr" },
      },
    },
    cgv: {
      title: "Algemene Voorwaarden",
      sections: {
        object: { title: "1. Doel", content: "Deze Algemene Voorwaarden regelen de contractuele relaties tussen {company} en haar klanten voor AI-diensten, softwareontwikkeling en bedrijfsoplossingen." },
        provider: { title: "2. Dienstverlener", company: "Bedrijf", siret: "SIRET", address: "Adres" },
        services: { title: "3. Aangeboden diensten", intro: "{company} biedt de volgende diensten:", items: ["Gespecialiseerde AI-agenten", "Maatwerk bedrijfsapplicaties (Prime Evolution)", "Document AI-oplossingen", "VEECTORIA Pulse - Transcriptieplatform", "AI-advies en integratie"] },
        quotes: { title: "4. Offertes en bestellingen", content: "Alle diensten zijn gebaseerd op een gedetailleerde offerte." },
        pricing: { title: "5. Prijzen en betaling", content1: "Prijzen in euro's exclusief BTW. BTW 20%. Betaalbaar binnen 30 dagen.", content2: "Bij te late betaling worden vertragingsrente toegepast." },
        delivery: { title: "6. Levering en termijnen", content: "Levertijden zijn indicatief. {company} streeft naar naleving van overeengekomen termijnen." },
        intellectual: { title: "7. Intellectueel eigendom", content: "Ontwikkelingen blijven eigendom van {company} tot volledige betaling." },
        confidentiality: { title: "8. Vertrouwelijkheid", content: "Beide partijen verbinden zich tot vertrouwelijkheid voor 3 jaar na contracteinde." },
        liability: { title: "9. Beperking van aansprakelijkheid", content: "De aansprakelijkheid van {company} is beperkt tot de contractwaarde." },
        law: { title: "10. Toepasselijk recht", content: "Frans recht is van toepassing. Bevoegde rechtbank is Parijs." },
      },
    },
    cookiesPolicy: {
      title: "Cookiebeleid",
      sections: {
        what: { title: "1. Wat is een cookie?", content: "Een cookie is een klein tekstbestand dat op uw apparaat wordt geplaatst bij het bezoeken van een website." },
        types: { title: "2. Gebruikte cookies", intro: "Onze website gebruikt de volgende cookies:", essential: "Essentiële cookies", essentialDesc: "Noodzakelijk voor de werking van de website.", analytics: "Analytische cookies", analyticsDesc: "Helpen ons het gebruik te begrijpen.", preferences: "Voorkeurscookies", preferencesDesc: "Onthouden uw instellingen." },
        retention: { title: "3. Bewaartermijn", content: "Cookies worden maximaal 13 maanden bewaard." },
        management: { title: "4. Cookiebeheer", intro: "U kunt uw cookie-instellingen op elk moment wijzigen:", items: ["Chrome: Instellingen → Privacy → Cookies", "Firefox: Opties → Privacy → Cookies", "Safari: Voorkeuren → Privacy → Cookies", "Edge: Instellingen → Cookies"] },
        contact: { title: "5. Contact", content: "Voor vragen over cookies, neem contact op:" },
      },
    },
  },
};
